import { sendPost } from "@/utils/request";
import { mySendPost, transformCities } from './addressV2';
import { getQueryString } from "../utils";

// 获取城市列表
function getCityData(params) {
  let city = getQueryString("city");
  const url = "/location/area/getcitylist";
  return mySendPost(url, {
    ...params,
    cityId: city || "",
  }).then(transformCities);
}

// 获取公告
function getNotice(params) {
  const url = "/notice/noticeContent";
  return sendPost(url, params, false);
}

// 获取快速搜索
function getQuickSearch(params) {
  const url = "/search/searchContract/quick/v2";
  return sendPost(url, params, false);
}

// 获取搜索词链
function getSearchUrl(params) {
  const url = "/word/super";
  return sendPost(url, params, false);
}

// 查询是否敏感词
function getSensitiveUrl(params) {
  const url = "/word/sensitive";
  return sendPost(url, params, false);
}

// 获取新工会头部数据
function getFindByUnion(params) {
  const url = "/mallUnion/unionConfig/findByUnion";
  return sendPost(url, params);
}

// 获取登录状态
function getLoginStatus(params) {
  const url = "/user/checkLogin";
  return sendPost(url, params, true);
}

// 获取工会菜单
function getFindUsableList(params) {
  const url = "/mallUnion/unionMallConfig/findUsableList";
  return sendPost(url, params);
}

//
function getIsNewUnion(params) {
  const url = "/mallUnion/union/isNewUnion";
  return sendPost(url, params);
}

// 获取老公会信息
function getLogo(params) {
  const url = "/mallunion/getLogo";
  return sendPost(url, params, true);
}

export default {
  getCityData,
  getNotice,
  getQuickSearch,
  getFindByUnion,
  getLoginStatus,
  getFindUsableList,
  getIsNewUnion,
  getLogo,
  getSearchUrl,
  getSensitiveUrl,
};
